import { isString } from 'lodash';
export const IconSize = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
    XLarge: 'x-large'
};
export const IconVariant = {
    Success: 'success',
    Danger: 'danger',
    Warning: 'warning',
    Info: 'info',
    Announcement: 'announcement',
    Primary: 'primary',
    Default: ''
};
export const isSymbolString = (svg) => isString(svg) && svg.includes('#');
export const isSymbolObject = (svg) => !!svg.id;
export const isComponent = (svg) => !isString(svg) && !isSymbolObject(svg);
export const isInlineSvg = (svg) => !isSymbolObject(svg) && !isComponent(svg) && !isSymbolString(svg);
